import { render, staticRenderFns } from "./ContactProperties.vue?vue&type=template&id=6c9fee6f&scoped=true"
import script from "./ContactProperties.vue?vue&type=script&lang=js"
export * from "./ContactProperties.vue?vue&type=script&lang=js"
import style0 from "./ContactProperties.vue?vue&type=style&index=0&id=6c9fee6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9fee6f",
  null
  
)

export default component.exports